import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { EvaluatorService } from '@/infra/services/evaluator';

interface GetListEvaluatorParams {
	company_id: string;
	organization_id: string;
}

const Service = EvaluatorService.getInstance();

export const useGetListEvaluator = (params: GetListEvaluatorParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_EVALUATOR, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
